import { Img } from "./components/img/img";
import { Base } from "./image.base";

export const Image = Object.assign(Base, {
    Img: Img
});
